/**
 * Created by hyr on 18/11/4.
 * 调用分享面板在share.js中
 * 更新share文案用法：(采用双向绑定方式（getter/setter），动态修改此数据后，分享逻辑中的分享数据会直接修改)
 * import shareData from './config.share';
 *
 * shareData.list = [...];//如需修改端内分享排序
 * shareData.hideMore = true/false;//是否隐藏更多和复制链接
 * ...
 *
 */

const staticUrl = 'http://cache.amap.com/h5/static/20180401flower/';
export default {
  list: ['weixin', 'pengyou', 'dingding', 'weibo', 'qq', 'qzone'],
  hideMore: false, // 是否隐藏更多和复制链接
  title: '运营活动',
  wbTopic: '', // 微博话题在此配置 例:#微博活动#...
  message: '运营活动详情',
  imgUrl: `${staticUrl}share_index_wx.jpg`,
  wbImgUrl: `${staticUrl}share_index_wb.jpg`,
  url: '',
};
